import Component from 'molbio/maps/linear/Component';
import {Layout} from 'molbio/maps/linear/LinearLayout';

class BlankLayout extends Layout {
  vMargin(): number {
    return 0;
  }
  boxHeight(): number {
    return 0;
  }
}

/** This view exists solely to ensure that a <g> tag with .selection-hidden-wrapper is rendered at a fixed
 * DOM location relative to other slice components.
 *
 * It implements the minimum interface required for a subclass of Component. Management of the wrapper's
 * child nodes is handled by SliceView.renderSelect().
 */
class SelectionHiddenWrapperView extends Component {
  layout!: BlankLayout;

  static initClass(): void {
    this.prototype.className = 'selection-hidden-wrapper';
  }
  initialize(): void {
    super.initialize();
    this.layout = new BlankLayout();
  }
  update(): void {}
}
SelectionHiddenWrapperView.initClass();

export default SelectionHiddenWrapperView;
